import { Data } from 'signup-constants/signupData/Data';
import { getFlowSteps } from '../flow-initial/getFlowConfig';
import { setNextSteps, replaceCurrentStep } from '../store/flow/action-creators';
import { Step } from 'signup-constants/Step';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { isExistingUser, isOAuthSignup } from '../app/verificationTypeSelectors';
import { getShouldAddHubletSelection } from '../flow-branches/branches/BranchAddHubletNewUser';
import { Tracker } from '../store/tracking/action-creators';
const getNormalizedGTKMDataPurchase = gtkmData => {
  var _gtkmData$Data$Compan, _gtkmData$Data$Compan2, _gtkmData$Data$Compan3;
  const hasCompanyName = Boolean((_gtkmData$Data$Compan = gtkmData[Data.CompanyName]) === null || _gtkmData$Data$Compan === void 0 ? void 0 : _gtkmData$Data$Compan.trim());
  const hasCompanySize = Boolean((_gtkmData$Data$Compan2 = gtkmData[Data.CompanySize]) === null || _gtkmData$Data$Compan2 === void 0 ? void 0 : _gtkmData$Data$Compan2.trim());
  const hasCompanyDomain = Boolean((_gtkmData$Data$Compan3 = gtkmData[Data.CompanyDomain]) === null || _gtkmData$Data$Compan3 === void 0 ? void 0 : _gtkmData$Data$Compan3.trim());
  const count = [hasCompanyName, hasCompanySize, hasCompanyDomain].filter(Boolean).length;
  return {
    hasCompanyName,
    hasCompanySize,
    hasCompanyDomain,
    count
  };
};
export const updateStepOrdersAfterAuthPurchase = ({
  gtkmData,
  dispatch,
  state,
  isFreeEmailDomain = false,
  isGTKMEndpointFailed = false
}) => {
  dispatch(Tracker.signupInteraction('purchase-gtkm-update-step-order-after-auth', {
    currentValue: isFreeEmailDomain
  }));
  const {
    postAccountCreation
  } = getFlowSteps();
  const {
    hasCompanyName,
    hasCompanySize,
    count
  } = getNormalizedGTKMDataPurchase(gtkmData);
  const postVerificationStepsDefault = [...(!hasCompanyName ? [Step.CompanyName] : []), ...(!hasCompanySize ? [Step.CompanySize] : []), Step.Review];
  const postVerificationStepsOnlyFoundDomain = [Step.CompanyDomain, Step.LoadingPage];
  const shouldUsePostVerificationStepsOnlyFoundDomain = count === 1 || !isExistingUser(state) && isFreeEmailDomain || isGTKMEndpointFailed;
  const postVerificationSteps = shouldUsePostVerificationStepsOnlyFoundDomain ? postVerificationStepsOnlyFoundDomain : postVerificationStepsDefault;
  const firstName = getSignupDataValue(state, Data.FirstName);
  const lastName = getSignupDataValue(state, Data.LastName);
  const nextSteps = [...(isOAuthSignup(state) || isExistingUser(state) ? [] : [Step.Password]), ...(isExistingUser(state) || isOAuthSignup(state) && firstName && lastName ? [] : [Step.Name]), ...postVerificationSteps, ...postAccountCreation];
  const shouldAddHubletSelection = getShouldAddHubletSelection(state);
  if (shouldAddHubletSelection) {
    nextSteps.push(Step.HubletSelection);
  }
  dispatch(replaceCurrentStep(nextSteps[0]));
  dispatch(setNextSteps(nextSteps.slice(1)));
  return nextSteps;
};
export const updateStepOrdersInDomainStepPurchase = ({
  gtkmData,
  dispatch,
  state
}) => {
  dispatch(Tracker.signupInteraction('purchase-gtkm-update-step-order-in-domain'));
  const {
    count
  } = getNormalizedGTKMDataPurchase(gtkmData);
  const nextSteps = count >= 3 ? [Step.Review] : [Step.CompanySize, Step.CompanyName];
  const shouldAddHubletSelection = getShouldAddHubletSelection(state);
  if (shouldAddHubletSelection) {
    nextSteps.push(Step.HubletSelection);
  }
  dispatch(setNextSteps(nextSteps));
  return nextSteps;
};